export default "__VITE_ASSET__LAesXARg__"